import React, { createContext, useContext } from 'react';
import { useIntl } from 'react-intl';
import { translate } from '@smovilgps/optimus-intl';
import { message } from 'antd-v6';

type ToastApi = {
	success: (intlKey: string, values?: Record<string, any>) => void;
	error: (intlKey?: string, values?: Record<string, any>) => void;
	info: (intlKey: string, values?: Record<string, any>) => void;
	warning: (intlKey: string, values?: Record<string, any>) => void;
	loading: (intlKey: string, values?: Record<string, any>) => void;
};

const ToastContext = createContext<ToastApi | null>(null);

export const AppToastProvider = ({ children }: { children: React.ReactNode }) => {
	const intl = useIntl();
	const [messageApi, contextHolder] = message.useMessage();

	const api: ToastApi = {
		success: (intlKey, values = {}) => {
			messageApi.success(intl.formatMessage(translate(intlKey), values));
		},
		error: (intlKey = 'commonError', values = {}) => {
			messageApi.error(intl.formatMessage(translate(intlKey), values));
		},
		info: (intlKey, values = {}) => {
			messageApi.info(intl.formatMessage(translate(intlKey), values));
		},
		warning: (intlKey, values = {}) => {
			messageApi.warning(intl.formatMessage(translate(intlKey), values));
		},
		loading: (intlKey, values = {}) => {
			messageApi.loading(intl.formatMessage(translate(intlKey), values));
		},
	};

	return (
		<ToastContext.Provider value={api}>
			{contextHolder}
			{children}
		</ToastContext.Provider>
	);
};

export const useAppToast = () => {
	const ctx = useContext(ToastContext);
	if (!ctx) throw new Error('useAppToast must be used inside AppToastProvider');
	return ctx;
};
